"use client";

import { hasArrayElements } from "@/apiUtils/commonUtils";
import { bannerGridContentType, linkType } from "@/apiUtils/constants";
import ArrowLeftIcon from "@/assets/icons/arrow-left.svg?react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg?react";
import NoImageSrc from "@/assets/images/no_image.svg";
import { BannerGridContentTile } from "@/common/lib/types";
import { Carousel, Slide } from "@/components/ui/carousel/Carousel";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
// import Image from "next/image";
import { CLink } from "../customLink/CustomLink";
import root from "react-shadow";
import CldImage from "@/components/ui/cldImg/CldImage";
import AllViewExpandableContent from "@/components/AllViewExpandableContent";

interface IProps {
  content: BannerGridContentTile;
  translations?: any; // Add translations prop for expandable content
}

const ContentTile = ({ content, translations }: IProps) => {
  if (content?.richText != undefined)
    return (
      <div className={`flex h-full flex-col justify-center p-8 md:px-28`}>
        <CLink href={content?.link?.url ?? ""}>
          <span className="content block">
            {/* <root.span>
              <style>
                {`
            p {
                margin: 0;
                padding: 0;
              }
            a {
                color: #666666;
              }
          `}
              </style>
              <span className="text mt-4" dangerouslySetInnerHTML={{ __html: content?.richText }} />
            </root.span> */}
            <AllViewExpandableContent 
              text={content?.richText} 
              translations={translations}
              customTextClassName="max-w-[72rem] text-start text-[0.875rem] md:text-[1.125rem] font-normal tracking-negative text-tertiary-6"
            />
          </span>
        </CLink>
      </div>
    );
  return (
    <div className="flex h-full flex-col px-8 pb-16 pt-8 md:px-12 md:pt-32">
      <div>
        <h2 className="text-size-22 font-medium lg:text-[32px]">{content?.title}</h2>
        <p className="pt-4 text-sm text-tertiary-6 lg:text-lg">{content?.description}</p>
        {content?.type === bannerGridContentType.IMAGE &&
          content?.images &&
          hasArrayElements(content?.images) ? (
          <div className="no-scrollbar mt-6 flex gap-2 overflow-x-auto whitespace-nowrap lg:mt-11">
            {content?.images?.map((image) => (
              <div key={image?.key} className="max-w-[184px] shrink-0">
                <CLink
                  href={image?.link?.url ?? "/"}
                  className="mt-9 block lg:mt-auto "
                  target={content?.link?.type === linkType.EXTERNAL ? "_blank" : ""}
                >
                  <CldImage
                    src={getCloudinaryURL(image?.media) ?? NoImageSrc}
                    width={400}
                    height={400}
                    alt={content?.title ?? "banner-grid-items"}
                    className="w-full object-cover invert-[2%]"
                  />
                </CLink>
              </div>
            ))}
          </div>
        ) : (
          <></>
        )}
        {content?.type === bannerGridContentType.PRODUCTS &&
          content?.products &&
          hasArrayElements(content?.products) ? (
          <div className="mt-6 md:mt-11">
            <Carousel
              autoPlay={{
                playOnInit: false,
              }}
              spacing={16}
              slides={content?.products?.map(
                (data) =>
                  ({
                    slideClasses: "basis-auto",
                    content: (
                      <CLink
                        href={
                          data?.landingPageBaseUrl ||
                          `/product/${data?.slug}/${data?.defaultVariantId}`
                        }
                      >
                        <CldImage
                          src={
                            data?.thumbnail ? getCloudinaryURL(data?.thumbnail) : NoImageSrc?.src
                          }
                          alt={data?.name}
                          width={166}
                          height={78}
                          className="h-auto invert-[2%] object-cover"
                        />
                      </CLink>
                    ),
                  }) as Slide,
              )}
              controls={{
                distance: "-32px",
                left: {
                  content: (
                    <div
                      className={cn(
                        "hidden p-2 md:block",
                        content?.products?.length < 4 ? "md:hidden" : "",
                      )}
                    >
                      <ArrowLeftIcon />
                    </div>
                  ),
                },
                right: {
                  content: (
                    <div
                      className={cn(
                        "hidden p-2 md:block",
                        content?.products?.length < 4 ? "md:hidden" : "",
                      )}
                    >
                      <ArrowRightIcon />
                    </div>
                  ),
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <CLink
        href={content?.link?.url ?? ""}
        className="mt-9 pt-4 text-sm font-semibold underline md:text-lg lg:mt-auto"
        target={content?.link?.type === linkType.EXTERNAL ? "_blank" : ""}
      >
        {content?.linkTitle}
      </CLink>
    </div>
  );
};

export default ContentTile;
